<template>
  <v-row>
    <v-col v-if="isloading" cols="12" class="justify-center d-flex">
      <v-progress-circular
        :size="small ? 34 : 50"
        :color="colorName"
        indeterminate
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" class="justify-center d-flex">
      <v-chip-group v-if="Balance.length" column light>
        <template v-for="(item, index) in Balance">
          <v-chip
            :small="small"
            :color="colorName"
            outlined
            :key="index + 'cashView'"
            ><strong
              >{{ item.AccountName ? item.AccountName : "Total" }}:
              <span :class="Textcolor">
                {{ item.Amount.toLocaleString() }}
                <span v-if="item.AmountType" :class="CashColor + '--text'">{{
                  item.AmountType
                }}</span>
              </span></strong
            >
          </v-chip>
        </template>
      </v-chip-group>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    Balance: { type: [Array, String], default: () => [] },
    isloading: { type: Boolean },
    small: { type: Boolean, default: false },
    colorName: { type: String, default: "indigo" },
    Textcolor: { type: String, default: "indigo--text" },
    CashColor: { type: String, default: "error" },
  },
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
